import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, EffectFlip } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-flip';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, EffectFlip]);

// Export for global use if needed
window.Swiper = Swiper

// PURE COUNTER
import PureCounter from "@srexi/purecounterjs";
window.PureCounter = PureCounter

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Plyr
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();
    Fancybox.bind("[data-fancybox]", {});

    const players = [];
    document.querySelectorAll('.audio-player').forEach(el => {
        players.push(new Plyr(el));
    });

    players.forEach(player => {
        player.on('play', () => {
            players.forEach(other => {
                if (other !== player) other.pause();
            });
        });
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
